import React, { Component } from "react";
import {
    RouteComponentProps,
    Route,
    Switch,
    Redirect,
    withRouter
} from "react-router-dom";
import {connect} from "react-redux";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import {homeStoreSelectors} from "../../store/store";
import HomePageIndex from "../HomePageIndex/HomePageIndex.component";

import ConfigurationsPage from "../../../configurations/components/ConfigurationsPage/ConfigurationsPage.component";
import LandingPage from "../LandingPage/LandingPage.component";
import "./HomeRouter.component.scss";

import HallsPageComponent from "../../../halls/components/HallsPage/HallsPage.component";
import UsersManagementPageComponent from "../../../auth/components/UsersManagement/UsersManagementPage.component";
import GamesPage from "../../../games/components/GamesPage/GamesPage.component";
import CreditsComponentPage from "../../../credits/credits.component";
import HelpComponentPage from "../../../help/help.component";
import KeyPage from "../../../configurationKey/components/KeyPage.component";
import VppsPage from "../../../vpp/components/VppsPage.component";
import HistoryPage from "../../../history/components/HistoryPage.component";
import RolesManagementPage from "../../../auth/components/RolesManagement/RolesManagement.component";
import UserProfilePage from "../../../auth/components/UserProfile/UserProfilePage.component";
import MailingList from "../../../mailing/components/MailingLists.component";
import PresetsPage from "../../../progressivePresets/components/PresetsPage.component";
import SpecialPrizesPresetsPage from "../../../specialPrizesPresets/components/SpecialPrizesPresetsPage.component";
import SubsidiariesPage from "../../../subsidiaries/components/SubsidiariesPage.component";
import SystemServerVersionsPage from "../../../systemServerVersions/components/SystemServerVersionsPage.component";
import RedirectPage from "../../../redirect/redirect.component";

import {
    checkPermission,
    isAdmin
} from "../../../../utils/Authorization/authorization";

export interface HomeRouterProps extends RouteComponentProps {
    usersLoading: boolean;
}
export interface HomeRouterState {
    loading: boolean
}

class HomeRouter extends Component<HomeRouterProps,HomeRouterState> {

    constructor(props) {
        super(props);
        this.state = {
            loading:false
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            ...prevState,
            loading : nextProps.usersLoading
        }
    }

    render() {
        return (
            <div id="HomeRouter">
                <Route
                    render={({ location }) => (
                        <TransitionGroup>
                            <CSSTransition
                                key={location.pathname}
                                classNames="fade"
                                timeout={550}
                            >
                                <Switch location={location}>
                                    <Route
                                        exact
                                        path="/"
                                        component={HomePageIndex}
                                    />
                                    <Route
                                        path="/home"
                                        component={LandingPage}
                                    />
                                    <Route
                                        path="/configurations"
                                        component={ConfigurationsPage}
                                    />
                                    {checkPermission("list_halls") && (
                                        <Route
                                            path="/halls"
                                            component={HallsPageComponent}
                                        />
                                    )}
                                    <Route
                                        path={"/user/profile/"}
                                        component={UserProfilePage}
                                    />

                                    {isAdmin() && (
                                        <Route
                                            path="/users"
                                            component={
                                                UsersManagementPageComponent
                                            }
                                        />
                                    )}

                                    {isAdmin() && (
                                        <Route
                                            path="/roles"
                                            component={RolesManagementPage}
                                        />
                                    )}

                                    {(checkPermission("manage_game_attributes") ||
                                        checkPermission("list_games") ||
                                        checkPermission("list_bundles")) && (
                                            <Route
                                                path="/games"
                                                component={GamesPage}
                                            />
                                        )}

                                    {checkPermission("list_vpp") && (
                                        <Route
                                            path="/vpp"
                                            component={VppsPage}
                                        />
                                    )}

                                    {checkPermission("activity_history") && (
                                        <Route
                                            path="/history"
                                            component={HistoryPage}
                                        />
                                    )}

                                    {(checkPermission("generate_key") ||
                                        checkPermission("history_key")) && (
                                            <Route
                                                path="/configuration-key"
                                                component={KeyPage}
                                            />
                                        )}

                                    {checkPermission("list_prog_presets") && (
                                        <Route
                                            path="/admin/progressives-presets"
                                            component={PresetsPage}
                                        />
                                    )}
                                    {checkPermission("list_prog_presets") && (
                                        <Route
                                            path="/admin/special-prizes-presets"
                                            component={SpecialPrizesPresetsPage}
                                        />
                                    )}
                                    {checkPermission("subsidiary_logos") && (
                                        <Route
                                            path="/admin/subsidiaries"
                                            component={SubsidiariesPage}
                                        />
                                    )}
                                    {isAdmin() && (
                                        <Route
                                            path="/admin/system-server-versions"
                                            component={SystemServerVersionsPage}
                                        />
                                    )}

                                    <Route
                                        path="/credits"
                                        component={CreditsComponentPage}
                                    />

                                    <Route
                                        path="/help"
                                        component={HelpComponentPage}
                                    />

                                    {checkPermission("mailing_list") && (
                                        <Route
                                            path="/admin/mailing"
                                            component={MailingList}
                                        />
                                    )}

                                    <Route path="/admin">
                                        <Route
                                            exact
                                            path="/admin/"
                                            render={() => (
                                                <Redirect to="/halls" />
                                            )}
                                        />
                                    </Route>

                                    {isAdmin() && (
                                        <Route
                                            path="/remote-access"
                                            component={() => (
                                                <RedirectPage url="https://www.dwservice.net/en/loginsignup.html" />
                                            )}
                                        />
                                    )}
                                </Switch>
                            </CSSTransition>
                        </TransitionGroup>
                    )}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    usersLoading: homeStoreSelectors.userLoading(state)
})
const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HomeRouter));

